"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="call-to-action" className="bg-background py-24 md:py-32 px-4 sm:px-6 lg:px-8 light">
      <div ref={ref} className={`container mx-auto max-w-4xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Card className="border border-primary/10 shadow-xl bg-card text-center p-12 md:p-20 lg:p-24 rounded-lg">
          <CardHeader className="px-0 pt-0 pb-6">
            <CardTitle className="text-4xl md:text-5xl lg:text-6xl font-serif text-primary tracking-tighter leading-tight">
              Begin with a Clear Review of the Matter
            </CardTitle>
          </CardHeader>
          <CardContent className="px-0 pb-0 flex flex-col items-center gap-10">
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed font-sans">
              Our office begins by identifying the relevant facts, documents, parties, and immediate questions before determining the appropriate next step.
            </p>
            <div className="flex flex-col items-center gap-6">
              <Button size="lg" asChild className="sm:w-auto text-lg px-10 h-14 rounded-lg shadow-md transition-all hover:shadow-lg">
                <Link to="/ContactUsPage">
                  Request a Consultation
                </Link>
              </Button>
              <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-primary">
                <Link to="tel:+19549259000">Call the Office</Link>
                <Link to="mailto:info@morrielevine.com">Email the Office</Link>
                <Link to="/SecureClientUploadPage">Existing Client Upload</Link>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}